/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Leaflet from 'leaflet'

import 'leaflet/dist/leaflet.css'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import '../Menu/InternalMenu.scss'
import './faq.scss'

import Logo from '../../../assets/svg/logoEnglish.svg'
import persianDarkLogo from '../../../assets/pictures/persianLogoDark.png'

import iconUrl from '../../../assets/svg/Location.svg'

import { get } from '../../../services/https'

import { MapContainer, TileLayer, Marker } from 'react-leaflet'

export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

function index() {
  const [faq, setFaq] = useState([])

  const position = [37.27579, 49.937]
  const Markers = () => {
    return (
      <Marker
        key={position}
        position={position}
        interactive={false} 
        icon={newicon}
      />
    )
  }

  useEffect(() => {
    get('/api/front/im/faqs').then(response => {
      console.log(response.data.data.docs[0].faq)
      setFaq(response.data.data.docs[0].faq)
    }).catch(err => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }, [])
  
  return (
    <div className='InternalMenu'>
      <ToastContainer rtl />
      <div className='countainer'>
        <div className='InternalMenu_logo'>
          <img src={Logo} alt="Logo" />
        </div>

        <div className="internalMenu_subtitle">
          کانولی سمفونی طعم ها !!
        </div>

        <div className="InternalMenu_category_title">
          سوالات متداول
        </div>

        <div className='InternalMenu_category_faq'>
          {faq.map((item, index) => (
            <div className='InternalMenu_category_faq_section' key={index}>
              <div className="InternalMenu_category_faq_section_qua">
                <span>
                  {item.faqQua}
                </span>
                <span>
                  -
                </span>
              </div>
              <div className='InternalMenu_category_faq_section_ans'>
                {item.faqAns}
              </div>
            </div>
          ))}
        </div>

        <div className='InternalMenu_footer'>
          <div className='InternalMenu_footer_left'>
            <img src={persianDarkLogo} alt="persianDarkLogo" />
            <span className='InternalMenu_footer_left_subtitle'>
              کانولی سمفونی طعم ها !!
            </span>
            <span>
              شماره های تماس :
            </span>
            <span>
              013-42135632 ،  013-42135632
            </span>
            <address>
              آدرس : آستانه اشرفیه ، میدان جمهوری
            </address>
          </div>
          <div className='InternalMenu_footer_center'>
            <span className='InternalMenu_footer_center_title'>
              لینک های دسترسی 
            </span>
            <ul>
              <li><a href="/internalMenu">منوی آنلاین</a></li>
              <li><a href="/internalMenu/reserve">رزرو میز</a></li>
              <li><a href="/internalMenu/job">استخدام</a></li>
              <li><a href="/internalMenu/faq">سوالات پر تکرار</a></li>
            </ul>
          </div>
          <div className='InternalMenu_footer_right'>
            <MapContainer 
              style={{ width: '350px', height: '300px', margin: '1em 0 0 0' }}
              center={position} 
              zoom={14}
              >
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              <Markers />
            </MapContainer>
          </div>
        </div>

        <div className="copyright">
          <span>کلیه ی حقوق مادی و معنوی این وبسایت متعلق به مجموعه کانولی است</span>
          <span>طراحی و توسعه توسط : <a href="https://ham-team.ir">هم تیم</a></span>
        </div>
      </div>
    </div>
  )
}

export default index